const TrainingVersion = Object.freeze({
    CURRENT: 1
})

export default TrainingVersion